<template>
  <router-link class="bjh-link" :to="to"><slot></slot></router-link>
</template>

<script>
  export default {
    name: "BjhLink",
    props: {
      to: {
        type: Object,
        default: null
      }
    }
  }
</script>

<style scoped>
  a.bjh-link {
    cursor: pointer;
    color: cornflowerblue;
    text-decoration: none;
  }
  a.bjh-link:hover, a.bjh-link:focus {
    cursor: pointer;
    color: cornflowerblue;
    text-decoration: underline;
  }
</style>
